import { useAccount, useDisconnect, useChainId, useBalance } from "wagmi";
import { useAppKit } from "@reown/appkit/react";
import { Wallet, LogOut, AlertTriangle } from "lucide-react";
import { shortAddr } from "@/lib/format";
import { BASE_CHAIN_ID } from "@/config/contracts";

export default function WalletButton() {
  const { open } = useAppKit();
  const { address, isConnected } = useAccount();
  const chainId = useChainId();
  const { disconnect } = useDisconnect();
  const { data: bal } = useBalance({ address, chainId: BASE_CHAIN_ID, query: { enabled: !!address } });

  if (!isConnected) {
    return (
      <button
        data-testid="connect-wallet-button"
        onClick={() => open()}
        className="btn-accent flex items-center gap-2 rounded-xl px-4 py-2.5 text-sm font-semibold text-white"
      >
        <Wallet size={16} /> Connect Wallet
      </button>
    );
  }

  const wrongChain = chainId !== BASE_CHAIN_ID;

  return (
    <div className="flex items-center gap-2">
      {wrongChain && (
        <button
          data-testid="switch-network-button"
          onClick={() => open({ view: "Networks" })}
          className="flex items-center gap-1.5 rounded-xl border border-amber-500/40 bg-amber-500/10 px-3 py-2 text-xs font-semibold text-amber-300"
        >
          <AlertTriangle size={14} /> Switch to Base
        </button>
      )}
      <button
        data-testid="wallet-account-button"
        onClick={() => open({ view: "Account" })}
        className="flex items-center gap-2 rounded-xl border border-white/10 bg-[#131824] px-3 py-2 text-sm font-semibold hover:border-blue-500/50 transition-colors"
      >
        <span className="h-2 w-2 rounded-full bg-[#00e699]" />
        {bal && (
          <span className="font-mono2 text-xs text-slate-400">
            {Number(bal.formatted).toFixed(3)} {bal.symbol}
          </span>
        )}
        <span className="font-mono2">{shortAddr(address)}</span>
      </button>
      <button
        data-testid="disconnect-button"
        onClick={() => disconnect()}
        title="Disconnect"
        className="rounded-xl border border-white/10 bg-[#131824] p-2.5 text-slate-400 hover:text-rose-400 hover:border-rose-500/40 transition-colors"
      >
        <LogOut size={16} />
      </button>
    </div>
  );
}
